import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';

import checkboard from './helperCheckboard';

class Checkboard extends PureComponent {
  static propTypes = {
    white: PropTypes.string,
    grey: PropTypes.string,
    size: PropTypes.string,
    renderers: PropTypes.object,
    borderRadius: PropTypes.string,
    boxShadow: PropTypes.string
  };

  static defaultProps = {
    size: 8,
    white: 'transparent',
    grey: 'rgba(0,0,0,.08)',
    renderers: {}
  };

  render() {
    const { white, grey, size, renderers, borderRadius, boxShadow } =
      this.props;

    const styles = {
      grid: {
        borderRadius,
        boxShadow,
        absolute: '0px 0px 0px 0px',
        background: `url(${checkboard.get(
          white,
          grey,
          size,
          renderers.canvas
        )}) center left`
      }
    };

    return <div style={styles.grid} />;
  }
}

export default Checkboard;
